import type { EditorConfig, LexicalNode, SerializedTextNode } from "lexical";

import { addClassNamesToElement } from "@lexical/utils";
import { $applyNodeReplacement, TextNode } from "lexical";

export class AtMentionNode extends TextNode {
  static getType(): string {
    return "at-mention";
  }

  static clone(node: AtMentionNode): AtMentionNode {
    return new AtMentionNode(node.__text, node.__key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const element = super.createDOM(config);
    addClassNamesToElement(element, config.theme.atMention);
    return element;
  }

  static importJSON(serializedNode: SerializedTextNode): AtMentionNode {
    return $createAtMentionNode().updateFromJSON(serializedNode);
  }

  canInsertTextBefore(): boolean {
    return false;
  }

  isTextEntity(): true {
    return true;
  }
}

export function $createAtMentionNode(text = ""): AtMentionNode {
  return $applyNodeReplacement(new AtMentionNode(text));
}

export function $isAtMentionNode(
  node: LexicalNode | null | undefined
): node is AtMentionNode {
  return node instanceof AtMentionNode;
}
